export const validateBeCode = (beCode?: string, isFMorSPVersion?: boolean) => {
  if (!isFMorSPVersion) return true;
  if (!beCode) {
    return false;
  }
  const dividerBecode = beCode.split(" ");

  if (dividerBecode.length <= 1) {
    return false;
  }
  if (!dividerBecode[0] || !dividerBecode[1]) return false;
  if (!dividerBecode[0].length || dividerBecode[0].length > 10) {
    return false;
  }

  return true;
};
